import { reactive } from 'vue';

export const navigationState = reactive({ visible: false, progress: 0 });

export function installNavigationFeedback(router) {
  let target;
  let advanceTimer;
  let hideTimer;
  const stop = () => {
    clearInterval(advanceTimer);
    clearTimeout(hideTimer);
  };
  const start = to => {
    stop();
    target = to;
    navigationState.progress = 15;
    navigationState.visible = true;
    advanceTimer = setInterval(() => {
      navigationState.progress += (90 - navigationState.progress) / 8;
    }, 200);
  };
  const finish = to => {
    if (target !== to) return;
    stop();
    target = null;
    navigationState.progress = 100;
    hideTimer = setTimeout(() => { navigationState.visible = false; }, 180);
  };
  const removeBefore = router.beforeEach(start);
  const removeAfter = router.afterEach(to => finish(to));
  const removeError = router.onError((error, to) => finish(to));
  return () => {
    stop();
    removeBefore();
    removeAfter();
    removeError();
    navigationState.visible = false;
  };
}
